import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

// Import all images
import breadcrumbBg from '../../assets/img/bg/breadcrumb-bg.png';
import cloudIcon from '../../assets/img/icons/cloud.png';
import ballonIcon from '../../assets/img/icons/ballon-sclation.png';
import blog1 from '../../assets/img/blog/blog-3-1.png';
import blog2 from '../../assets/img/blog/blog-3-2.png';
import blog3 from '../../assets/img/blog/blog-3-3.png';
import recentPost1 from '../../assets/img/blog/recent-post-1-1.png';
import recentPost2 from '../../assets/img/blog/recent-post-1-2.png';
import recentPost3 from '../../assets/img/blog/recent-post-1-3.png';
import instagram1 from '../../assets/img/instagram/insta-post-1-1.png';
import instagram2 from '../../assets/img/instagram/insta-post-1-2.png';
import instagram3 from '../../assets/img/instagram/insta-post-1-3.png';
import instagram4 from '../../assets/img/instagram/insta-post-1-4.png';
import instagram5 from '../../assets/img/instagram/insta-post-1-5.png';
import related1 from '../../assets/img/blog/blog-2-1.png';
import related2 from '../../assets/img/blog/blog-1-2.png';
import related3 from '../../assets/img/blog/blog-1-1.png';

const Blog = () => {
    const searchInputRef = useRef(null);

    // Blog posts data
    const blogPosts = [
        {
            id: 1,
            image: blog1,
            author: "frenk",
            date: "April 27, 2024",
            title: "Indonesia Your Dream Destination",
            excerpt: "Rainbow's high techngy systems with the help of reoving unseen dusothtls miyoutes and bed bugs harmfully diseases because of dirters. This also includes haging home bes linens share provid disg specialized deep unseen unseen echngy mites client.",
            link: "/destinations"
        },
        {
            id: 2,
            image: blog2,
            author: "frenk",
            date: "April 27, 2024",
            title: "Indonesia Your Dream Destination",
            excerpt: "Rainbow's high techngy systems with the help of reoving unseen dusothtls miyoutes and bed bugs harmfully diseases because of dirters. This also includes haging home bes linens share provid disg specialized deep unseen unseen echngy mites client.",
            link: "/destinations"
        },
        {
            id: 3,
            image: blog3,
            author: "frenk",
            date: "April 27, 2024",
            title: "famiglia bambini riviera romagnola",
            excerpt: "Rainbow's high techngy systems with the help of reoving unseen dusothtls miyoutes and bed bugs harmfully diseases because of dirters. This also includes haging home bes linens share provid disg specialized deep unseen unseen echngy mites client.",
            link: "/destinations"
        }
    ];

    // Recent posts data
    const recentPosts = [
        {
            id: 1,
            image: recentPost1,
            date: "April 27, 2024",
            title: "Return Flights Included Adventure",
            link: "/destinations"
        },
        {
            id: 2,
            image: recentPost2,
            date: "April 27, 2024",
            title: "Indonesia Your Dream Destination",
            link: "/destinations"
        },
        {
            id: 3,
            image: recentPost3,
            date: "April 27, 2024",
            title: "famiglia bambi riviera romagnola",
            link: "/destinations"
        }
    ];

    // Categories data
    const categories = [
        { name: "Threat Protection", count: 23 },
        { name: "Dark Web Monitor", count: 10 },
        { name: "Dedicated IP", count: 9 },
        { name: "Secure Internet Browsing", count: 14 },
        { name: "Multi-Device Support", count: 12 },
        { name: "Private DNS", count: 12 }
    ];

    // Tags data
    const tags = [
        "Adventure", "Hiking", "Trekking", "Family Tours", "Cycling", "Rafting", "Paragliding"
    ];

    // Instagram posts data
    const instagramPosts = [
        instagram1, instagram2, instagram3, instagram4, instagram5, instagram1
    ];

    // Related posts data
    const relatedPosts = [
        {
            id: 1,
            image: related1,
            category: "Adventure",
            date: "May 15, 2024",
            author: "Sarah Johnson",
            title: "Top 10 Hiking Trails in the Swiss Alps",
            excerpt: "Discover breathtaking alpine scenery with our guide to the most spectacular hiking trails in Switzerland.",
            link: "/DestinationDetails",
            readTime: "5 min read"
        },
        {
            id: 2,
            image: related2,
            category: "Culture",
            date: "May 10, 2024",
            author: "Michael Chen",
            title: "Hidden Gems of Southeast Asia",
            excerpt: "Explore lesser-known destinations in Southeast Asia that offer authentic cultural experiences away from tourist crowds.",
            link: "/DestinationDetails",
            readTime: "7 min read"
        },
        {
            id: 3,
            image: related3,
            category: "Beach",
            date: "May 5, 2024",
            author: "Emily Rodriguez",
            title: "Best Tropical Islands for Your Next Vacation",
            excerpt: "From the Maldives to the Caribbean, find your perfect island paradise with our comprehensive guide.",
            link: "/DestinationDetails",
            readTime: "6 min read"
        }
    ];

    // Handle search form submission
    const handleSearch = (e) => {
        e.preventDefault();
        const searchTerm = searchInputRef.current?.value;
        if (searchTerm) {
            console.log('Searching for:', searchTerm);
            // Implement search functionality here
        }
    };

    // Animation effect on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            { threshold: 0.1 }
        );

        const animatedElements = document.querySelectorAll('.fade-anim, .move-anim');
        animatedElements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <main className="main">
            {/* Breadcrumb Section */}
            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: `url(${breadcrumbBg})` }}
            >
                <img
                    src={cloudIcon}
                    alt="vs-breadcrumb-icon"
                    className="vs-breadcrumb-icon-1 animate-parachute"
                    style={{ position: 'absolute' }}
                />
                <img
                    src={ballonIcon}
                    alt="vs-breadcrumb-icon"
                    className="vs-breadcrumb-icon-2 animate-parachute"
                    style={{ position: 'absolute' }}
                />
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">Latest News</h1>
                            </div>
                            <div className="breadcrumb-menu">
                                <ul className="custom-ul">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>our blog</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Blog Content Section */}
            <section className="vs-blog-wrapper space">
                <div className="container">
                    <div className="row gx-3 g-5">
                        {/* Main Blog Content */}
                        <div className="col-lg-8">
                            <div className="row g-4 gy-4 gy-sm-5">
                                {blogPosts.map((post) => (
                                    <div key={post.id} className="col-12">
                                        <div className="vs-blog vs-blog-box3">
                                            <div className="blog-img">
                                                <Link to={post.link}>
                                                    <img
                                                        className="img"
                                                        src={post.image}
                                                        alt="blog"
                                                    />
                                                </Link>
                                            </div>
                                            <div className="blog-content">
                                                <div className="blog-meta">
                                                    <span className="blog-author">
                                                        Written by:<Link to="/blog">{post.author}</Link>
                                                    </span>
                                                    <span className="blog-date">
                                                        <i className="fa-regular fa-calendar-days"></i>
                                                        {post.date}
                                                    </span>
                                                </div>
                                                <h3 className="blog-title">
                                                    <Link to={post.link}>
                                                        {post.title}
                                                    </Link>
                                                </h3>
                                                <p className="blog-text">
                                                    {post.excerpt}
                                                </p>
                                                <div className="blog-footer">
                                                    <Link to={post.link} className="blog-link">
                                                        read more
                                                        <i className="fa-sharp fa-regular fa-angles-right"></i>
                                                    </Link>
                                                    <div className="share-box">
                                                        <span>
                                                            share
                                                            <i className="fa-solid fa-share-nodes"></i>
                                                        </span>
                                                        <ul className="custom-ul">
                                                            <li>
                                                                <a href="#" target="_blank" rel="noopener noreferrer">
                                                                    <i className="fa-brands fa-facebook-f"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" target="_blank" rel="noopener noreferrer">
                                                                    <i className="fa-brands fa-x-twitter"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" target="_blank" rel="noopener noreferrer">
                                                                    <i className="fa-brands fa-instagram"></i>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#" target="_blank" rel="noopener noreferrer">
                                                                    <i className="fa-brands fa-linkedin-in"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                {/* Search Widget */}
                                <div className="widget widget_search">
                                    <h5 className="widget_title title-shep">Search</h5>
                                    <form className="search-form" onSubmit={handleSearch}>
                                        <input 
                                            type="text" 
                                            placeholder="Search here..." 
                                            ref={searchInputRef}
                                        />
                                        <button type="submit"><i className="far fa-search"></i></button>
                                    </form>
                                </div>

                                {/* Recent Posts Widget */}
                                <div className="widget widget_recent-posts">
                                    <h5 className="widget_title title-shep">related posts</h5>
                                    <div className="recent-post-wrap">
                                        {recentPosts.map((post) => (
                                            <div key={post.id} className="recent-post">
                                                <div className="media-img">
                                                    <Link to={post.link}>
                                                        <img
                                                            src={post.image}
                                                            alt="Blog Image"
                                                        />
                                                    </Link>
                                                </div>
                                                <div className="media-body">
                                                    <div className="recent-post-meta">
                                                        <Link to="/blog">
                                                            <i className="fa-solid fa-calendar"></i>
                                                            {post.date}
                                                        </Link>
                                                    </div>
                                                    <h6 className="post-title">
                                                        <Link className="text-inherit" to={post.link}>
                                                            {post.title}
                                                        </Link>
                                                    </h6>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Categories Widget */}
                                <div className="widget widget_categories">
                                    <h5 className="widget_title title-shep">Categories</h5>
                                    <ul className="custom-ul">
                                        {categories.map((category, index) => (
                                            <li key={index}>
                                                <Link to="/blog">{category.name}</Link>
                                                <span>{category.count}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Tags Widget */}
                                <div className="widget widget_meta">
                                    <h5 className="widget_title title-shep">Tags</h5>
                                    <div className="tagcloud">
                                        {tags.map((tag, index) => (
                                            <Link key={index} to="/blog">{tag}</Link>
                                        ))}
                                    </div>
                                </div>

                                {/* Instagram Widget */}
                                <div className="widget">
                                    <h5 className="widget_title title-shep">Follow Us</h5>
                                    <div className="sidebar-gallery">
                                        {instagramPosts.map((post, index) => (
                                            <div key={index} className="gallery-box">
                                                <div className="post-thumb">
                                                    <img
                                                        src={post}
                                                        alt="instagram"
                                                        className="w-100"
                                                    />
                                                </div>
                                                <a
                                                    href={post}
                                                    title={`Gallery-${index + 1}`}
                                                    className="gallery-link"
                                                ></a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Related Content Section - UPDATED */}
            <section className="related-content-section" style={{
                padding: '80px 0',
                backgroundColor: '#f8f9fa'
            }}>
                <div className="container">
                    <div className="section-title text-center" style={{
                        marginBottom: '60px'
                    }}>
                        <span style={{
                            display: 'block',
                            color: '#f7bd34ff',
                            fontSize: '18px',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '2px',
                            marginBottom: '15px'
                        }}>
                            Discover More
                        </span>
                        <h2 style={{
                            fontSize: '42px',
                            fontWeight: '700',
                            color: '#232f66ff',
                            marginBottom: '15px',
                            lineHeight: '1.2'
                        }}>
                            You Might Also Like
                        </h2>
                        <p style={{
                            fontSize: '18px',
                            color: '#666',
                            maxWidth: '600px',
                            margin: '0 auto',
                            lineHeight: '1.6'
                        }}>
                            Explore more travel stories, tips, and destination guides from our blog
                        </p>
                    </div>
                    
                    <div className="row g-4">
                        {relatedPosts.map((post) => (
                            <div key={post.id} className="col-md-6 col-lg-4">
                                <div className="related-post-card" style={{
                                    background: '#fff',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                                    transition: 'all 0.3s ease',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    {/* Image Container */}
                                    <div style={{
                                        position: 'relative',
                                        overflow: 'hidden',
                                        height: '250px'
                                    }}>
                                        <img 
                                            src={post.image} 
                                            alt={post.title}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease'
                                            }}
                                        />
                                        {/* Category Badge */}
                                        <div style={{
                                            position: 'absolute',
                                            top: '20px',
                                            left: '20px',
                                            backgroundColor: '#f75e34ff',
                                            color: '#fff',
                                            padding: '8px 16px',
                                            borderRadius: '20px',
                                            fontSize: '12px',
                                            fontWeight: '700',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px'
                                        }}>
                                            {post.category}
                                        </div>
                                        {/* Overlay on Hover */}
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            background: 'linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.3))',
                                            opacity: 0,
                                            transition: 'opacity 0.3s ease'
                                        }}></div>
                                    </div>

                                    {/* Content Container */}
                                    <div style={{
                                        padding: '30px',
                                        flex: '1',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                        {/* Meta Information */}
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '15px',
                                            fontSize: '14px',
                                            color: '#666'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="fa-regular fa-calendar-days" style={{ color: '#f75e34ff' }}></i>
                                                <span>{post.date}</span>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <i className="fa-regular fa-clock" style={{ color: '#f75e34ff' }}></i>
                                                <span>{post.readTime}</span>
                                            </div>
                                        </div>

                                        {/* Author */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            marginBottom: '15px'
                                        }}>
                                            <div style={{
                                                width: '32px',
                                                height: '32px',
                                                backgroundColor: '#232f66ff',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#fff',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                            }}>
                                                {post.author.split(' ').map(n => n[0]).join('')}
                                            </div>
                                            <span style={{
                                                fontSize: '14px',
                                                color: '#666',
                                                fontWeight: '500'
                                            }}>
                                                By {post.author}
                                            </span>
                                        </div>

                                        {/* Title */}
                                        <h3 style={{
                                            fontSize: '20px',
                                            fontWeight: '700',
                                            color: 'black',
                                            lineHeight: '1.4',
                                            marginBottom: '15px',
                                            flex: '1'
                                        }}>
                                            <Link 
                                                to={post.link}
                                                style={{
                                                    color: 'inherit',
                                                    textDecoration: 'none',
                                                    transition: 'color 0.3s ease'
                                                }}
                                            >
                                                {post.title}
                                            </Link>
                                        </h3>

                                        {/* Excerpt */}
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            marginBottom: '20px',
                                            fontSize: '15px',
                                            flex: '1'
                                        }}>
                                            {post.excerpt}
                                        </p>

                                        {/* Read More Button */}
                                        <div style={{ marginTop: 'auto' }}>
                                            <Link 
                                                to={post.link}
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    color: '#f75e34ff',
                                                    textDecoration: 'none',
                                                    fontWeight: '600',
                                                    fontSize: '15px',
                                                    transition: 'all 0.3s ease',
                                                    padding: '8px 0'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.gap = '12px';
                                                    e.target.style.color = '#232f66ff';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.gap = '8px';
                                                    e.target.style.color = '#f75e34ff';
                                                }}
                                            >
                                                Read More
                                                <i className="fa-sharp fa-regular fa-angles-right" style={{
                                                    transition: 'transform 0.3s ease'
                                                }}></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* View All Button */}
                    {/* <div className="text-center" style={{ marginTop: '50px' }}>
                        <Link 
                            to="/blog"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '12px',
                                backgroundColor: '#232f66ff',
                                color: '#fff',
                                padding: '16px 35px',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                fontWeight: '600',
                                fontSize: '16px',
                                transition: 'all 0.3s ease',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                                boxShadow: '0 5px 15px rgba(35, 47, 102, 0.3)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f7bd34ff';
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 8px 25px rgba(247, 189, 52, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#232f66ff';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 5px 15px rgba(35, 47, 102, 0.3)';
                            }}
                        >
                            View All Articles
                            <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                    </div> */}
                </div>

                {/* Add hover effects with style tag */}
                <style jsx>{`
                    .related-post-card:hover {
                        transform: translateY(-10px);
                        box-shadow: 0 20px 40px rgba(0,0,0,0.15);
                    }
                    
                    .related-post-card:hover img {
                        transform: scale(1.05);
                    }
                    
                    .related-post-card:hover .image-overlay {
                        opacity: 1;
                    }
                `}</style>
            </section>
        </main>
    );
};

export default Blog;